import type { FaqItem } from '@/modules/seo/content/shared';

const stripTags = (html: string) => html.replace(/<[^>]*>/g, '').trim();

interface IFaqSchemaProps {
  items: FaqItem[];
}

export const FaqSchema = ({ items }: IFaqSchemaProps) => {
  if (!items?.length) return null;

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map(({ question, answer }) => ({
      '@type': 'Question',
      name: question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: stripTags(answer),
      },
    })),
  };

  return (
    <script
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
      type="application/ld+json"
    />
  );
};
